import { useCallback, useState, useContext, useEffect, useRef } from "react";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { Button } from "primereact/button";

// import {
//   addOrgAwardsAward,
//   deleteOrgAwards,
// } from "../MyProfile/Service/profileService";
import { addOrgAwardsAward, deleteOrgAwards } from "../../MyProfile/Service/profileService";
import { GetMasterTypeData, uploadDoc } from "../../../../Services/Global-Services/GlobalServices";
import UploadFile_KEYS from "../../../../Services/Global-Services/UploadFile_Keys";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { TostMsg } from "../../../../App";
import { EmployeeAwardsGet } from "../../AwardList/Services/awardService";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import LoginLoader from "../../../../Shared/Sidebar/LoginLoader";
import { getRawPermissionsArray } from "../../../../Routes/AuthGard/usePermissions";

let employeeId;
const Add_New_AssessmentsHTML = () => {
  const [columns, setColumns] = useState([
    "Employee Name",
    "First Reviewer",
    "Second Reviewer",
    "Hr",
  ]); // Columns state
  const [rows, setRows] = useState([{}]); // Rows state
  const [editIndex, setEditIndex] = useState(null);
  const [orgAwardList, setOrgAwardList] = useState([]);
  const [selectedId, SetSelectedId] = useState();
  const [awardFrequencyLst, setAwardFrequencyLst] = useState([]);
  const defaultImage = "/images/placeholder_profile.png";
  const [file, setFile] = useState(null);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [awardsEditId, setAwardsEditId] = useState(null);
  const [Isloading, setIsloading] = useState(false);
  const [IsImageloading, setIsImageloading] = useState(false);
  let toster = useContext(TostMsg);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [deleteContent, setSeleteContent] = useState([]);
  const [create, setCreate] = useState(false);
  const [update, setUpdate] = useState(false);
  const [deleted, setDeleted] = useState(false);
  let userPermissions = getRawPermissionsArray();
  const [errors, setErrors] = useState({});
  useEffect(
    (employeeId) => {
      getMasterTypeList();
      permissionGiven();
      //   getEmployeeIdData();
      GetOrgAwards();
    },
    [employeeId]
  );

  const validateAwardData = (data, index) => {
    const newErrors = {};

    newErrors[`${index}-AwardName`] =
      !data.AwardName || data.AwardName.trim() === ""
        ? "Name is required"
        : undefined;

    newErrors[`${index}-FrequencyName`] =
      !data.FrequencyName || data.FrequencyName.trim() === ""
        ? "Frequency is required"
        : undefined;

    newErrors[`${index}-awardImage`] =
      !data.awardImage || data.awardImage === ""
        ? "Image is required"
        : undefined;

    setErrors((prev) => ({ ...prev, ...newErrors }));

    const isValid = Object.values(newErrors).every(
      (error) => error === undefined
    );
    return isValid;
  };

  async function getMasterTypeList() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "AwardFrequency",
    };
    try {
      const data = await GetMasterTypeData(params);
      setAwardFrequencyLst(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  const permissionGiven = () => {
    userPermissions?.map((UserPermission) => {
      if (UserPermission.PermissionName == "Award.Create") {
        setCreate(true);
      } else if (UserPermission.PermissionName == "Award.Update") {
        setUpdate(true);
      } else if (UserPermission.PermissionName == "Award.Delete") {
        setDeleted(true);
      }
    });
  };
  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setSeleteContent(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setSeleteContent(msg?.Desc);
      }
    });
  }, []);

  async function GetOrgAwards() {
    setIsloading(true);
    let body = {
      OrgId: userDetails?.OrgId,
    };
    try {
      let responce = await EmployeeAwardsGet(body);
      setOrgAwardList(responce?.Data);
    } catch (err) {
      toster.current.error(ERROR_LIST.AwardMasterData);
    } finally {
      setIsloading(false);
    }
  }

  // Add a new row
  const handleAddRow = () => {
    setOrgAwardList([
      ...orgAwardList,
      { AwardName: "", FrequencyName: "", awardImage: "" },
    ]);
    setEditIndex(orgAwardList.length);
  };

  // Delete the last row
  const handleRemoveRow = () => {
    setRows(rows.slice(0, -1));
  };

  // Remove a specific row
  const handleRemoveSpecificRow = (rowIdx) => () => {
    const updatedRows = rows.filter((_, idx) => idx !== rowIdx);
    setRows(updatedRows);
  };

  const [data, setData] = useState({
    AwardName: "",
    FrequencyName: "",
    awardImage: "",
  });
  const handleChange = (rowIdx, colName) => (e) => {
    const { value } = e.target;
    const updatedRows = [...orgAwardList];
    updatedRows[rowIdx] = { ...updatedRows[rowIdx], [colName]: value };
    setOrgAwardList(updatedRows);
    const updatedData = { ...data, [colName]: value };
    setData(updatedData);

    validateAwardData(updatedData, rowIdx);
  };

  const handleFileChange = useCallback(async (event, index) => {
    const selectedFile = event.target.files;
    setFile({ files: selectedFile, index });
  }, []);
  const cancelAward = () => {
    GetOrgAwards();
    setOrgAwardList((prevList) => {
      setEditIndex(null);
      const lastItem = prevList[prevList.length - 1];
      const isEmpty =
        !lastItem.AwardName && !lastItem.FrequencyName && !lastItem.awardImage;

      if (isEmpty) {
        return prevList.slice(0, -1); // remove last item
      }
      return prevList;
    });
  };

  useEffect(() => {}, [selectedId]);
  async function addAwardOrg(index, data) {
    let selectedFrequencyIdId;
    if (selectedId) {
      selectedFrequencyIdId = selectedId;
    } else {
      selectedFrequencyIdId = data?.FrequencyId;
    }
    const body = {
      ModifiedBy: userDetails.EmpId ?? 0,
      FrequencyId: Number(selectedFrequencyIdId) ?? 0,
      OrgId: userDetails?.OrgId,
      Id: data?.id ?? 0,
      AwardName: data.AwardName,
      AwardImage: data.awardImage,
    };
    try {
      await addOrgAwardsAward(body);
      if (awardsEditId) {
        GetMasterSystemAlertList("Award_Updated", 0);
      } else {
        GetMasterSystemAlertList("Award_Added", 0);
      }
      SetSelectedId(null);
      setOrgAwardList([]);
      setEditIndex(null);
      GetOrgAwards();
      setIsloading(false);
    } catch (err) {
      setIsloading(false);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handleEditClick = (index) => {
    setEditIndex(index);
  };
  const handleCreatedlstDelete = (Id) => {
    setAwardsEditId(Id);
  };
  async function DeleteAwards() {
    setIsloading(true);
    if (awardsEditId) {
      let body = {
        Id: awardsEditId,
      };
      try {
        let awardDeleteList = await deleteOrgAwards(body);
        if (awardDeleteList) {
          GetMasterSystemAlertList("Award_Deleted", 0);
          setIsloading(false);
          GetOrgAwards();
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  useEffect(() => {
    if (file?.files) {
      uploadPolicyDocFile(file.files, file.index);
    }
  }, [file]);

  async function uploadPolicyDocFile(files, index) {
    setIsImageloading(true);
    if (files) {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("files", files[i]);
      }
      let params = {
        UploadType: UploadFile_KEYS?.Assessment,
        RefId: 0,
      };
      try {
        const response = await uploadDoc(params, formData);
        const data = await response;
        const ImageURL = data?.Data;

        if (ImageURL?.[0]) {
          handleChange(
            index,
            "awardImage"
          )({
            target: { value: ImageURL[0] },
          });
        }

        setIsImageloading(false);
      } catch (error) {
        setIsImageloading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      }
    } else {
      setIsImageloading(false);
      toster.current.warn("No file selected");
    }
  }

  // let SearchValue = "";
  // const handleInputChange = (event) => {
  //   debouncedSearch(event.target.value);
  // };

  // const debouncedSearch = useCallback(
  //   debounce((value) => {
  //     SearchValue = value;
  //     let filteredList = orgAwardList.filter((award) =>
  //       award.AwardName?.toLowerCase().includes(SearchValue?.toLowerCase())
  //     );
  //     if (SearchValue != "") {
  //       setOrgAwardList(filteredList);
  //     } else {
  //       GetOrgAwards();
  //     }
  //   }, 800),
  //   [orgAwardList]
  // );
  const stepperRef = useRef(null);
  return (
    <div className="container-fluid">
      <div className="row g-3 assessment-module">
        <div className="col-xl-12">
          <div className="form-head d-flex flex-wrap align-items-center">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">Add New Assessment</h2>
            </div>
            <div className="rightside-tabs">
              {/* <select className='form-control'>
                                           <option disabled>Select Period</option>
                                           <option selected >01 April 2022 - 31 March 2023</option>
                                           <option>01 April 2021 - 31 March 2022</option>
                                           <option>01 April 2020 - 31 March 2021</option>
                                       </select> */}
              <Link to="/AssessmentCycles">
                <button
                  className="cancelbutton w-auto float-right"
                  style={{ minWidth: "fit-content" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="17"
                    fill="currentColor"
                    className="bi bi-arrow-left me-2"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                    ></path>
                  </svg>
                  Back
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div className="col-xl-9">
          <div className="addnew-assessmentform flex justify-content-center">
            <Stepper ref={stepperRef} style={{ flexBasis: "50rem" }}>
              <StepperPanel header="Assessment Parameters">
                <div className="flex flex-column h-12rem">
                  <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium">
                    <div className="row g-4">
                      <div className="col-md-6">
                        <label for="Type" className="form-label-file">
                          Assessment Period Start
                          <i className="inValidError">*</i>
                        </label>
                        <input type="date" className="form-control" />
                      </div>
                      <div className="col-md-6">
                        <label for="Type" className="form-label-file">
                          Assessment Period End<i className="inValidError">*</i>
                        </label>
                        <input type="date" className="form-control" />
                      </div>
                      <div className="col-md-6">
                        <label for="Type" className="form-label-file">
                          Assessment Start<i className="inValidError">*</i>
                        </label>
                        <input type="date" className="form-control" />
                      </div>
                      <div className="col-md-6">
                        <label for="Type" className="form-label-file">
                          Assessment End<i className="inValidError">*</i>
                        </label>
                        <input type="date" className="form-control" />
                      </div>
                      <div className="col-md-6">
                        <label for="Type" className="form-label-file">
                          Self Assessment Last Date
                          <i className="inValidError">*</i>
                        </label>
                        <input type="date" className="form-control" />
                      </div>
                      <div className="col-md-6">
                        <label for="Type" className="form-label-file">
                          First Reviewer Last Date
                          <i className="inValidError">*</i>
                        </label>
                        <input type="date" className="form-control" />
                      </div>
                      <div className="col-md-6">
                        <label for="Type" className="form-label-file">
                          Reviewer By<i className="inValidError">*</i>
                        </label>
                        <select
                          id="Type"
                          name="Type"
                          className="form-control wide"
                          fdprocessedid="imegyo"
                        ></select>
                      </div>
                      <div className="col-md-6">
                        <label for="Type" className="form-label-file">
                          Title<i className="inValidError">*</i>
                        </label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="col-md-12">
                        <label for="Type" className="form-label-file">
                          Description<i className="inValidError">*</i>
                        </label>
                        <textarea
                          rows={5}
                          cols={1}
                          className="form-control h-auto"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex pt-5 justify-content-between text-right">
                  <Button
                    label="Save and Exit"
                    className="savebutton w-auto"
                    iconPos="right"
                  />
                  <Button
                    label="Save and Continue"
                    className="publish-click w-auto"
                    iconPos="right"
                    onClick={() => stepperRef.current.nextCallback()}
                  />
                </div>
              </StepperPanel>
              <StepperPanel header="Question Setup">
                <div className="flex flex-column h-12rem">
                  <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="add-questions">
                          <div className="questionslist-title">
                            <p>No.</p>
                            <p>Category</p>
                            <p>Question</p>
                            <p>Weightage %</p>
                          </div>
                          <div className="questionlist-detail-cols">
                            <strong>1</strong>
                            <input type="text" className="form-control" />
                            <input type="text" className="form-control" />
                            <input type="number" className="form-control" />
                          </div>
                          <div className="questionlist-detail-cols">
                            <strong>2</strong>
                            <input type="text" className="form-control" />
                            <input type="text" className="form-control" />
                            <input type="number" className="form-control" />
                          </div>
                          <div className="questionlist-detail-cols">
                            <strong>3</strong>
                            <input type="text" className="form-control" />
                            <input type="text" className="form-control" />
                            <input type="number" className="form-control" />
                          </div>
                          <div className="questionlist-detail-cols">
                            <strong>4</strong>
                            <input type="text" className="form-control" />
                            <input type="text" className="form-control" />
                            <input type="number" className="form-control" />
                          </div>
                          <div className="questionlist-detail-cols">
                            <strong>5</strong>
                            <input type="text" className="form-control" />
                            <input type="text" className="form-control" />
                            <input type="number" className="form-control" />
                          </div>
                          <div className="question-add">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              className="bi bi-plus"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                            </svg>
                            Add more question
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex pt-5 justify-content-between text-right">
                  <Button
                    label="Back"
                    severity="secondary"
                    className="cancelbutton bg-dark text-white"
                    onClick={() => stepperRef.current.prevCallback()}
                  />
                  <Button label="Save and Exit" className="savebutton w-auto" />
                  <Button
                    label="Save and Continue"
                    className="publish-click w-auto"
                    iconPos="right"
                    onClick={() => stepperRef.current.nextCallback()}
                  />
                </div>
              </StepperPanel>
              <StepperPanel header="Add Employee">
                <div className="flex flex-column h-12rem">
                  <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium">
                    <div
                      className="title-text"
                      style={{ position: "relative" }}
                    >
                      <h4>Add Employee</h4>
                      {!editIndex && (
                        <button
                          className="addaward-btn"
                          data-toggle="tooltip"
                          data-placement="top"
                          title=""
                          data-bs-original-title=""
                          fdprocessedid="izng1j"
                          onClick={handleAddRow}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-plus"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                          </svg>
                          Employee
                        </button>
                      )}
                    </div>
                    <table
                      className="table table-bordered table-hover"
                      id="tab_logic"
                    >
                      <thead>
                        <tr>
                          <th className="text-center">#</th>
                          {columns.map((colName, colIdx) => (
                            <th key={colIdx} className="text-left">
                              {colName}
                            </th>
                          ))}
                          <th className="text-left" style={{ width: "100px" }}>
                            Action
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {orgAwardList?.map((data, index) => (
                          <tr key={index}>
                            <td className="text-center">{index + 1}</td>
                            {editIndex === index ? (
                              <>
                                <td>
                                  <input
                                    value={data.AwardName}
                                    onChange={handleChange(index, "AwardName")}
                                    placeholder="Name"
                                    className={`form-control ${
                                      errors[`${index}-AwardName`]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                  />
                                  {errors[`${index}-AwardName`] && (
                                    <div className="invalid-feedback">
                                      {errors[`${index}-AwardName`]}
                                    </div>
                                  )}
                                </td>

                                <td>
                                  <select
                                    onChange={(e) => {
                                      const selectedId = e.target.value;
                                      SetSelectedId(selectedId);
                                      const selectedOption =
                                        awardFrequencyLst.find(
                                          (opt) =>
                                            Number(opt.Id) ===
                                            Number(selectedId)
                                        );
                                      handleChange(
                                        index,
                                        "FrequencyName"
                                      )({
                                        target: {
                                          value: selectedOption?.Name || "",
                                        },
                                      });
                                    }}
                                    value={
                                      awardFrequencyLst.find(
                                        (opt) => opt.Name === data.FrequencyName
                                      )?.Id || ""
                                    }
                                    className={`form-control ${
                                      errors[`${index}-FrequencyName`]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                  >
                                    <option value="" disabled>
                                      Choose...
                                    </option>
                                    {awardFrequencyLst?.map((option) => (
                                      <option key={option.Id} value={option.Id}>
                                        {option.Name}
                                      </option>
                                    ))}
                                  </select>
                                  {errors[`${index}-FrequencyName`] && (
                                    <div className="invalid-feedback">
                                      {errors[`${index}-FrequencyName`]}
                                    </div>
                                  )}
                                </td>

                                <td>
                                  {" "}
                                  <div className="loadresumes">
                                    <div className="inner">
                                      {data.awardImage ? (
                                        <img
                                          src={data.awardImage}
                                          className="editaddimg"
                                        />
                                      ) : (
                                        <>
                                          {IsImageloading ? (
                                            <LoginLoader />
                                          ) : (
                                            <img
                                              src="/images/org-img/learn/add.png"
                                              className="editaddimg"
                                            />
                                          )}
                                        </>
                                      )}
                                    </div>

                                    <label
                                      htmlFor={`file-upload-${index}`}
                                      className="custom-file-upload"
                                    >
                                      <i
                                        className="fa fa-upload me-2"
                                        aria-hidden="true"
                                      ></i>
                                      Upload Award Image
                                    </label>

                                    <input
                                      type="file"
                                      id={`file-upload-${index}`}
                                      style={{
                                        display: "none",
                                      }}
                                      accept="image/*"
                                      onChange={(e) =>
                                        handleFileChange(e, index)
                                      }
                                    />
                                    {errors[`${index}-awardImage`] && (
                                      <div className="text-danger mt-1">
                                        {errors[`${index}-awardImage`]}
                                      </div>
                                    )}
                                  </div>
                                </td>

                                <td>
                                  <>
                                    <img
                                      onClick={() => {
                                        cancelAward();
                                      }}
                                      src="/images/org-img/profile/close.png"
                                      title="Cancel"
                                      className="editactions me-2"
                                      style={{ width: "17px" }}
                                    />
                                    <img
                                      onClick={() => {
                                        if (validateAwardData(data, index)) {
                                          addAwardOrg(index, data);
                                        }
                                      }}
                                      src="/images/org-img/profile/check.png"
                                      title="Confirm"
                                      className="editactions"
                                      style={{ width: "17px" }}
                                    />
                                  </>
                                </td>
                              </>
                            ) : (
                              <>
                                <td>{data?.AwardName}</td>
                                <td>{data?.FrequencyName}</td>
                                <td className="">
                                  {data?.awardImage ? (
                                    <img
                                      src={data?.awardImage || defaultImage}
                                      onError={handleImageError}
                                      style={{
                                        width: "auto",
                                        height: "30px",
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src={data?.awardImage}
                                      className="w-4"
                                    />
                                  )}
                                </td>

                                <td className="">
                                  <button
                                    disabled={editIndex != null}
                                    className="editactions me-2"
                                    onClick={() => handleEditClick(index)}
                                  >
                                    <img
                                      src="/images/tickets/edit-ico.svg"
                                      className=""
                                      title="Edit"
                                    />
                                  </button>
                                  <button
                                    className="editactions"
                                    title="Delete"
                                    data-bs-toggle="modal"
                                    data-bs-target="#delete-Award"
                                    onClick={() => {
                                      handleCreatedlstDelete(data?.id);
                                      GetMasterSystemAlertList(
                                        "Delete_Award",
                                        1
                                      );
                                    }}
                                  >
                                    <img
                                      src="/images/tickets/delete.svg"
                                      className=""
                                      title="Delete"
                                    />
                                  </button>
                                </td>
                              </>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="flex pt-5 justify-content-between text-right">
                  <Button
                    label="Back"
                    severity="secondary"
                    className="cancelbutton bg-dark text-white"
                    onClick={() => stepperRef.current.prevCallback()}
                  />
                  <Button label="Save and Exit" className="savebutton w-auto" />
                </div>
              </StepperPanel>
            </Stepper>
          </div>
        </div>
        <div className="col-xl-3">
          <div className="content">
            <div>
              <h1>About Organization</h1>
              <p>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Aut
                praesentium nemo eum exercitationem unde.
              </p>
            </div>
            <img src="/images/pms/assessment.png" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add_New_AssessmentsHTML;
